import BranchesService from '@/services/BranchesService';

export default {
  namespaced: true,
  state: {
    list: null,
  },
  mutations: {
    m_list(state: any, list: any) {
      state.list = list;
    },
  },
  actions: {
    async a_init_Branches({ dispatch }: any) {
      await dispatch('a_get_list');
    },
    async a_get_list({ commit }: any) {
      await BranchesService.getList().then((res: any) => {
        if (res.status === 200) {
          commit('m_list', res.data);
        }
      });
    },
    async a_create_branche({ commit }: any, { params }: any) {
      console.log(commit, params);
      await BranchesService.create(params).then((res: any) => {
        if (res.status === 200) {
          console.log(res.data);
          // dispatch('a_get_list');
          // return {success: true};
        }
      });
    },
    async a_import_branches({ commit }: any, { params }: any) {
      await BranchesService.import(params)
        .then((res: any) => {
          if (res.status === 200) {
            console.log(res.data);
            // dispatch('a_get_list');
            // return {success: true};
          }
        })
        .catch((err: any) => {
          console.error(err);
        });
    },
  },
  getters: {
    list: (state: any) => state.list,
  },
};
